import { render } from "./KeyframeSelectorTool.vue?vue&type=template&id=51d13512"
import script from "./KeyframeSelectorTool.vue?vue&type=script&lang=ts"
export * from "./KeyframeSelectorTool.vue?vue&type=script&lang=ts"

import "./KeyframeSelectorTool.vue?vue&type=style&index=0&id=51d13512&lang=sass"
script.render = render

export default script